import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IAppState {
  overlayOpen: Readonly<boolean>;
  weatherWarningBannerOpen: Readonly<boolean>;
  weatherWarningTarget: Readonly<string | undefined>;
}

const initialState: Readonly<IAppState> = {
  overlayOpen: false,
  weatherWarningBannerOpen: false,
  weatherWarningTarget: undefined,
};

export const appSlice = createSlice({
  name: 'appState',
  initialState,
  reducers: {
    REDUX_APP_SET_OVERLAY_OPEN: (state) => {
      return {
        ...state,
        overlayOpen: true,
      };
    },
    REDUX_APP_SET_OVERLAY_CLOSED: (state) => {
      return {
        ...state,
        overlayOpen: false,
        weatherWarningTarget: undefined,
      };
    },
    REDUX_APP_SET_WEATHER_WARNING_BANNER: (
      state,
      action: PayloadAction<{ isOpen: boolean; weatherWarningTarget?: string }>,
    ) => {
      return {
        ...state,
        weatherWarningBannerOpen: action.payload.isOpen,
        weatherWarningTarget: action.payload.weatherWarningTarget,
      };
    },
    REDUX_APP_CLEAR_WEATHER_WARNING_TARGET: (state) => {
      return {
        ...state,
        weatherWarningTarget: undefined,
      };
    },
  },
});

export const {
  REDUX_APP_SET_OVERLAY_OPEN,
  REDUX_APP_SET_OVERLAY_CLOSED,
  REDUX_APP_SET_WEATHER_WARNING_BANNER,
  REDUX_APP_CLEAR_WEATHER_WARNING_TARGET,
} = appSlice.actions;

export const appReducer = appSlice.reducer;
